import { persist, createSessionStorage } from "@macfja/svelte-persistent-store";
import { get, writable } from "svelte/store";

// The vehicle list already returns every row's plate number, so the vehicle
// header can read it from here instead of spending a ~1s detail call on a
// vehicle the user just clicked. Session-scoped so a refresh keeps it too.
const plateNumbersByVehicleId = persist(
	writable({}),
	createSessionStorage(),
	"mrPlateNumbersByVehicleId"
);

export function rememberPlateNumbers(vehicles) {
	const next = { ...get(plateNumbersByVehicleId) };
	let changed = false;
	for (const vehicle of vehicles ?? []) {
		const { vehicleId, plateNumber } = vehicle ?? {};
		if (vehicleId === undefined || vehicleId === null || !plateNumber) {
			continue;
		}
		if (next[vehicleId] !== plateNumber) {
			next[vehicleId] = plateNumber;
			changed = true;
		}
	}
	if (changed) plateNumbersByVehicleId.set(next);
}

export function knownPlateNumber(vehicleId) {
	if (vehicleId === undefined || vehicleId === null) return "";
	return get(plateNumbersByVehicleId)[vehicleId] ?? "";
}
